import { Field } from '@sitecore-jss/sitecore-jss-nextjs';

import { ExtendedItem } from 'src/types/ExtendedItem';
import { FilterGroup } from 'src/types/FilterGroup';

export function mapFilterGroup(items: ExtendedItem[]): FilterGroup[] | undefined {
	if (!items) {
		console.error('Null Argument Error - Item is null, unable to create filter group.');
		return undefined;
	}
	if (items.length < 1) {
		return undefined;
	}

	return items.map((filterGroup) => {
		const opt: FilterGroup = {
			id: filterGroup.id,
			title: (filterGroup?.fields?.Title as Field<string>).value,
			dtoPropertyName: (filterGroup?.fields?.DtoPropertyName as Field<string>).value,
			options: (filterGroup.fields.Options as ExtendedItem[]).map((option) => {
				const textField = (option?.fields?.Title as Field) ?? option?.fields['Meta Name'];

				return {
					id: option.id,
					title: textField?.value?.toString(),
				};
			}),
		};

		return opt;
	});
}
